import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getMe } from '../../../me/data/datasources/get-me';

/**
 * `PUT /client/:cid/webhooks` with cb's field names (`location`, `general`, `transaction`), trimmed, `''` to clear
 * one. Each URL must be https with a domain name (the route answers 400 to http, an IP address or localhost). The
 * route replaces all nine keys; the form starts from all nine (`readWebhooks`), so none is lost.
 */
export const updateWebhooks = async (
  location_webhook: string,
  general_webhook: string,
  transaction_webhook: string,
  order_events: object,
  trip_events: object,
  task_events: object,
  driver_events: object,
  wallet_events: object,
  transaction_events: object
): Promise<any> => {
  await lpRequest('PUT', clientPath('/webhooks'), {
    body: {
      location: (location_webhook || '').trim(),
      general: (general_webhook || '').trim(),
      transaction: (transaction_webhook || '').trim(),
      order_events,
      trip_events,
      task_events,
      driver_events,
      wallet_events,
      transaction_events
    }
  });

  return getMe();
};
